var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42533 2.22499C8.4181 2.21675 8.41054 2.20868 8.40268 2.20081C8.36084 2.15898 8.31343 2.1261 8.26284 2.10219C8.0768 2.01279 7.84688 2.0452 7.69265 2.19942C7.67939 2.21269 7.66703 2.22651 7.65557 2.24081L3.80648 6.0899C3.61122 6.28516 3.61122 6.60175 3.80648 6.79701C4.00174 6.99227 4.31833 6.99227 4.51359 6.79701L7.55292 3.75768L7.55292 13.4577C7.55292 13.7338 7.77678 13.9577 8.05292 13.9577C8.32906 13.9577 8.55292 13.7338 8.55292 13.4577L8.55292 3.7668L11.5817 6.79562C11.777 6.99088 12.0936 6.99088 12.2888 6.79562C12.4841 6.60036 12.4841 6.28378 12.2888 6.08851L8.42533 2.22499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUp);
export default __webpack_public_path__ + "static/media/ic_arrow_up.b599c3e14febe4bc7b11a116cf46a56d.svg";
export { ForwardRef as ReactComponent };